// src/frontend_react/src/components/ui/Typography/Typography.js
import React from 'react';
import styles from './Typography.module.css';

const Typography = ({
  children,
  variant = 'body1',
  component,
  color = 'primary',
  fontWeight,
  align = 'left',
  noWrap = false,
  gutterBottom = false,
  paragraph = false,
  className = '',
  // --- FIX: Consume layout props ---
  style,
  textAlign,
  alignSelf,
  flexGrow,
  mt, mb, ml, mr, mx, my, m,
  borderBottom,
  ...props
}) => {
  const variantToComponentMap = {
    h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4', h5: 'h5', h6: 'h6',
    subtitle1: 'h6', subtitle2: 'h6', 
    body1: 'p', body2: 'p',      
    caption: 'span', overline: 'span', buttonText: 'span', inherit: 'span',    
  };

  const Component = component || (paragraph && variantToComponentMap[variant] !== 'p' ? 'p' : variantToComponentMap[variant]) || 'span';

  const classNames = [
    styles.typographyBase,
    styles[variant] || styles.body1,
    styles[`color-${color}`] || '',
    fontWeight ? styles[`fontWeight-${fontWeight}`] : '',
    styles[`align-${align}`] || '',
    noWrap ? styles.noWrap : '',
    (gutterBottom || (paragraph && Component === 'p')) ? styles.gutterBottom : '',
    className,
  ].filter(Boolean).join(' ');

  const combinedStyle = { ...style };
  if (textAlign) combinedStyle.textAlign = textAlign;
  if (alignSelf) combinedStyle.alignSelf = alignSelf;
  if (flexGrow) combinedStyle.flexGrow = flexGrow;
  if (borderBottom) combinedStyle.borderBottom = borderBottom;
  
  const getSpacingValue = (v) => typeof v === 'number' ? `${v * 8}px` : v;
  if (mt !== undefined) combinedStyle.marginTop = getSpacingValue(mt);
  if (mb !== undefined) combinedStyle.marginBottom = getSpacingValue(mb);
  if (ml !== undefined) combinedStyle.marginLeft = getSpacingValue(ml);
  if (mr !== undefined) combinedStyle.marginRight = getSpacingValue(mr);
  if (mx !== undefined) { combinedStyle.marginLeft = getSpacingValue(mx); combinedStyle.marginRight = getSpacingValue(mx); }
  if (my !== undefined) { combinedStyle.marginTop = getSpacingValue(my); combinedStyle.marginBottom = getSpacingValue(my); }
  if (m !== undefined) combinedStyle.margin = getSpacingValue(m);

  const predefinedColorVariants = ['primary', 'secondary', 'placeholder', 'error', 'success', 'info', 'warning', 'inherit'];
  if (color && !predefinedColorVariants.includes(color) && !styles[`color-${color}`]) {
    combinedStyle.color = color;
  }

  return (
    <Component className={classNames} style={combinedStyle} {...props}>
      {children}
    </Component>
  );
};

export default Typography;